module.exports = __webpack_public_path__ + "static/media/pedro.1abd1144.jpg";